import React from 'react'

import { useMutation } from '@apollo/client'
import { Person } from '@material-ui/icons'

import { UserContext } from '../../App'
import { EDIT_USER_AVATAR } from '../../graphql/mutations'
import { useProfilePictureStyles } from '../../styles'
import handleImageUpload from '../../utils/handleImageUpload'

function ProfilePicture({ size, image, isOwner }) {
  const classes = useProfilePictureStyles({
    isOwner,
    size
  })
  const { currentUserId } = React.useContext(UserContext)
  const inputRef = React.createRef()
  const [editUserAvatar] = useMutation(EDIT_USER_AVATAR)
  const [img, setImg] = React.useState(image)

  function openFileInput() {
    inputRef.current.click()
  }

  async function handelUpdateProfilePic(event) {
    const url = await handleImageUpload(
      event.target.files[0],
      'instagram-avatar'
    )
    const variables = {
      id: currentUserId,
      profileImage: url
    }
    await editUserAvatar({
      variables
    })
    setImg(url)
  }

  return (
    <section className={classes.section}>
      <input
        style={{ display: 'none' }}
        ref={inputRef}
        type="file"
        onChange={handelUpdateProfilePic}
      />
      {image ? (
        <div
          className={classes.wrapper}
          onClick={isOwner ? openFileInput : () => null}
        >
          <img src={img} alt="User profile" className={classes.image} />
        </div>
      ) : (
        <div className={classes.wrapper}>
          <Person className={classes.person} />
        </div>
      )}
    </section>
  )
}

export default ProfilePicture
